import { render, staticRenderFns } from "./portfolio-header.component.vue?vue&type=template&id=57681542"
import script from "./portfolio-header.component.vue?vue&type=script&lang=js"
export * from "./portfolio-header.component.vue?vue&type=script&lang=js"
import style0 from "./portfolio-header.component.vue?vue&type=style&index=0&id=57681542&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports